import { Button, Container } from '@mui/material';
import { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { Navigate, useNavigate, useParams } from 'react-router-dom';
import { SCENARIOS } from '../../data/scenarios';
import { logEvent } from '../../utils/ga';
import { ScenarioCalculator } from './ScenarioCalculator';
import styles from './ScenarioPage.module.css';

function ScenarioPage() {
  const navigate = useNavigate();
  const { scenarioId } = useParams<{ scenarioId: string }>();
  const scenario = SCENARIOS.find((item) => item.id === scenarioId);

  useEffect(() => {
    if (scenarioId && scenario) {
      logEvent('scenario', scenarioId, 'view');
    }
  }, [scenario, scenarioId]);

  if (!scenario) {
    return <Navigate to="/" replace />;
  }

  return (
    <div className={styles.root}>
      <Helmet>
        <title>{scenario.metaTitle}</title>
        <meta name="description" content={scenario.metaDescription} />
      </Helmet>

      <Container maxWidth="sm">
        <div className={styles.heroQuestion}>
          <h1>{scenario.heroQuestion}</h1>
        </div>

        <ScenarioCalculator scenario={scenario} />

        <div className={styles.conceptBox}>
          <p>{scenario.conceptExplain}</p>
        </div>

        <div className={styles.relatedLinks}>
          <p className={styles.relatedTitle}>더 정확한 계산이 필요하다면</p>
          {scenario.relatedLinks.map((link) => (
            <Button
              key={link.href}
              variant="outlined"
              onClick={() => navigate(link.href)}
              sx={{ justifyContent: 'space-between', borderColor: '#cbd5e1', color: '#111827' }}
            >
              {link.label} →
            </Button>
          ))}
        </div>
      </Container>
    </div>
  );
}

export default ScenarioPage;
